import React from 'react';

import { NationalScienceDay2023 } from 'views/CurricularClass52023/components';
const ExtraCurricularActivitiesPage = () => {
  return <NationalScienceDay2023 />;
};

export default ExtraCurricularActivitiesPage;